export default __webpack_public_path__ + "static/media/HitPaw-Online-Audio-Converter.png";